// src/components/admin/blog/SchedulePicker.jsx
import React, { useState } from 'react';
import { FiCalendar, FiClock } from 'react-icons/fi';

export const SchedulePicker = ({ value, onChange }) => {
  const [date, setDate] = useState(value ? new Date(value) : new Date());
  const [isOpen, setIsOpen] = useState(false);

  const handleDateChange = newDate => {
    const updatedDate = new Date(newDate);
    setDate(updatedDate);
    onChange(updatedDate.toISOString());
  };

  const formatDateTime = dateObj => {
    if (!dateObj) return 'Select date and time';
    return dateObj.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-3 py-2 rounded-lg border flex items-center justify-between bg-transparent"
        style={{ borderColor: 'var(--border)', color: 'var(--text)' }}
      >
        <div className="flex items-center gap-2">
          <FiCalendar className="w-4 h-4" style={{ color: 'var(--muted)' }} />
          <span>{formatDateTime(date)}</span>
        </div>
        <FiClock className="w-4 h-4" style={{ color: 'var(--muted)' }} />
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          <div
            className="absolute top-full left-0 mt-2 p-4 rounded-xl border shadow-lg z-50 animate-fade-in-up"
            style={{
              backgroundColor: 'var(--bg)',
              borderColor: 'var(--border)',
            }}
          >
            <input
              type="datetime-local"
              value={date.toISOString().slice(0, 16)}
              onChange={e => handleDateChange(e.target.value)}
              className="px-3 py-2 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500 bg-transparent"
              style={{ borderColor: 'var(--border)', color: 'var(--text)' }}
            />
            <div className="flex gap-2 mt-3">
              <button
                onClick={() => {
                  const tomorrow = new Date();
                  tomorrow.setDate(tomorrow.getDate() + 1);
                  handleDateChange(tomorrow);
                  setIsOpen(false);
                }}
                className="flex-1 px-2 py-1 text-sm rounded border hover:bg-black/5 dark:hover:bg-white/5"
                style={{ borderColor: 'var(--border)' }}
              >
                Tomorrow
              </button>
              <button
                onClick={() => {
                  const nextWeek = new Date();
                  nextWeek.setDate(nextWeek.getDate() + 7);
                  handleDateChange(nextWeek);
                  setIsOpen(false);
                }}
                className="flex-1 px-2 py-1 text-sm rounded border hover:bg-black/5 dark:hover:bg-white/5"
                style={{ borderColor: 'var(--border)' }}
              >
                Next Week
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
